/**
 * 账户信息
 */
<template>
    <div>
      <div class="login-title">四川省知识产权发展研究中心专利价值评估系统</div>
      <div class="login-title-en">Sichuan Intellectual Property Development Research Center Patent Value Evaluation System</div>
      <div class="eval-tab">
         <div :class="checkTab == 1 ? 'eval-tab-item-active':'eval-tab-item'" @click="jumpApplyEval()">价值评估</div>
         <div :class="checkTab == 2 ? 'eval-tab-item-active':'eval-tab-item'" @click="jumpEvalRecord()">评估记录</div>
         <!-- <div :class="checkTab == 3 ? 'eval-tab-item-active':'eval-tab-item'" @click="jumpApplyDrafts()">客户管理</div> -->
         <div :class="checkTab == 4 ? 'eval-tab-item-active':'eval-tab-item'" @click="jumpPersonCenter()">个人中心</div>
      </div>
    </div>
</template>
<script>
    export default {
        name: 'cusNav',
        data() {
            return {
             checkTab: '',
            }
        },
        created() {
            let path = this.$route.path
            if(path == '/client/patentSearch'){
                this.checkTab = 1
            }
            if(path == '/client/evalRecord'){
                this.checkTab = 2
            }
            if(path == '/client/customerClient'){
                this.checkTab = 3
            }
            if(path == '/client/personCenter'){
                this.checkTab = 4
            }
        },
        methods: {
         // 跳转申请评估
         jumpApplyEval(){
            let tab = this.checkTab
            if(tab != 1){
                this.$router.push({ path: '/client/patentSearch'});
            }
         },
         // 跳转评估记录
         jumpEvalRecord(){
            let tab = this.checkTab
            if(tab != 2){
                this.$router.push({ path: '/client/evalRecord'});
            }
         },
         // 跳转客户管理
         jumpApplyDrafts(){
            let tab = this.checkTab
            if(tab != 3){
                this.$router.push({ path: '/client/customerClient'});
            }
         },
         // 跳转个人中心
         jumpPersonCenter(){
            let tab = this.checkTab
            if(tab != 4){
                this.$router.push({ path: '/client/personCenter'});
            }
         },
        }
    }
</script>
<style scoped>
 .login-title {
    font-size: 36px;
    font-weight: 700;
    padding-top: 24px;
  }
  .login-title-en {
    font-size: 16px;
    color: #5a5a5a;
    margin-top: 10px;
  }
  .eval-tab {
   /* width: 900px; */
   width: 680px;
   display: flex;
   justify-content: space-between;
   margin: 40px auto;
  }
  .eval-tab-item {
   width: 200px;
   height: 40px;
   line-height: 40px;
   text-align: center;
   font-size: 18px;
   font-weight: 700;
   border-radius: 46px;
   background-color: #fff;
   cursor: pointer;
   filter: drop-shadow(0 4px 2px rgba(0,0,0,0.25));
  }
  .eval-tab-item-active {
   width: 200px;
   height: 40px;
   line-height: 40px;
   text-align: center;
   font-size: 18px;
   font-weight: 700;
   border-radius: 46px;
   color: #FFFFFF;
   background-color: #2A91DD;
   cursor: pointer;
   filter: drop-shadow(0 4px 2px rgba(0,0,0,0.25));
  }
</style>


// WEBPACK FOOTER //
// src/components/cusNav.vue